<template>
  <el-dialog
    title="审核入驻申请"
    :visible.sync="open_edit"
    width="500px"
    :before-close="handleClose"
  >
    <el-form size="small" :model="form" label-width="100px">
      <el-form-item label="用户信息">
        <div style="display: flex; align-items: center;">
          <img v-if="form.avatarUrl" :src="form.avatarUrl" width="40" height="40" style="border-radius: 50%; margin-right: 10px;" />
          <div>
            <div>{{ form.nickName || '未设置' }}</div>
            <div class="gray9">ID: {{ form.user_id }}</div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="联系电话">
        <span>{{ form.phone || '未填写' }}</span>
      </el-form-item>

      <el-form-item label="当前状态">
        <el-tag :type="form.status === 1 ? 'success' : form.status === 0 ? 'warning' : 'danger'">
          {{ getStatusText(form.status) }}
        </el-tag>
      </el-form-item>

      <el-form-item label="审核结果" prop="audit_result" required>
        <el-radio-group v-model="auditForm.result">
          <el-radio :label="1">通过</el-radio>
          <el-radio :label="2">拒绝</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="审核备注" prop="remark" v-if="auditForm.result === 2">
        <el-input
          type="textarea"
          :rows="3"
          v-model="auditForm.remark"
          placeholder="请输入拒绝原因（必填）"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UserApi from '@/api/user.js';

export default {
  props: {
    open_edit: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      auditForm: {
        result: 1, // 1:通过, 2:拒绝
        remark: ''
      }
    };
  },
  watch: {
    open_edit(val) {
      if (val) {
        // 打开弹窗时重置表单
        this.auditForm = {
          result: 1,
          remark: ''
        };
      }
    }
  },
  methods: {
    /*关闭弹窗*/
    handleClose() {
      this.$emit('closeDialog', {
        openDialog: false,
        type: 'close'
      });
    },

    /*状态文本转换*/
    getStatusText(status) {
      const statusMap = {
        0: '待审核',
        1: '审核通过',
        2: '审核拒绝'
      };
      return statusMap[status] || '未知状态';
    },

    /*提交审核*/
    handleSubmit() {
      if (this.auditForm.result === 2 && !this.auditForm.remark) {
        this.$message.warning('请填写拒绝原因');
        return;
      }

      this.loading = true;
      
      const params = {
        settled_log_id: this.form.settled_log_id,
        status: this.auditForm.result,
        remark: this.auditForm.remark || ''
      };

      UserApi.auditSettled(params, true)
        .then(res => {
          this.loading = false;
          if (res.code === 1) {
            this.$message.success('审核成功');
            this.$emit('closeDialog', {
              openDialog: false,
              type: 'success'
            });
          } else {
            this.$message.error(res.msg || '审核失败');
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message.error('审核失败');
        });
    }
  }
};
</script>

<style scoped>
.gray9 {
  color: #999;
  font-size: 12px;
}

.el-form-item {
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/user/setting/part/Serrlededit.vue